var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 80,
    viewBox: "0 0 92 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.7149 34.2864C31.5348 34.2864 11.4298 56.2075 11.4298 70.0448C11.4298 76.2768 16.2172 80 24.2403 80C32.9616 80 38.7204 75.5215 45.7149 75.5215C52.7702 75.5215 58.5451 80 67.1896 80C75.2127 80 80.0001 76.2768 80.0001 70.0448C80.0001 56.2075 59.8951 34.2864 45.7149 34.2864ZM19.4153 32.0347C17.5582 25.8473 11.8369 21.8402 6.63698 23.083C1.43706 24.3259 -1.27182 30.349 0.58529 36.5364C2.4424 42.7238 8.16374 46.7309 13.3637 45.488C18.5636 44.2452 21.2725 38.2221 19.4153 32.0347ZM34.5437 28.324C40.0686 26.8705 42.8328 19.4063 40.7186 11.6529C38.6043 3.89941 32.4116 -1.20587 26.8867 0.247684C21.3617 1.70123 18.5975 9.1654 20.7118 16.9188C22.826 24.6723 29.0206 29.7794 34.5437 28.324ZM84.7911 23.0848C79.5912 21.842 73.8716 25.8491 72.0127 32.0365C70.1556 38.2239 72.8645 44.247 78.0644 45.4898C83.2643 46.7327 88.9839 42.7256 90.8428 36.5382C92.6999 30.3508 89.991 24.3277 84.7911 23.0848ZM56.8862 28.324C62.4111 29.7776 68.6039 24.6723 70.7181 16.9188C72.8324 9.1654 70.0681 1.70302 64.5432 0.247684C59.0183 -1.20765 52.8255 3.89941 50.7113 11.6529C48.597 19.4063 51.3613 26.8705 56.8862 28.324Z",
    fill: "#F26739"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaw);
export default __webpack_public_path__ + "static/media/paw.7ab477524e4dac5b0bd7bafbbc7d2b46.svg";
export { ForwardRef as ReactComponent };